/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import ViewerControllerVideo from '../controller/viewer-controller-video';

/**
 * Typ média video.
 * Používá se pouze URL ze serveru bez podpory offline stavu.
 * @implements {ViewerType}
 */
class ViewerTypeVideo {
  /**
   * Vytvoří instanci.
   * @param {ViewerSourceCreator} viewerSourceCreator Poskytovatel zdroje pro zobrazení média.
   * @returns {ViewerTypeVideo} Nová instance.
   */
  constructor(viewerSourceCreator) {
    this.viewerSourceCreator = viewerSourceCreator;
  }

  /** @inheritdoc */
  createController() {
    return new ViewerControllerVideo();
  }

  /** @inheritdoc */
  getCheckFile(medium) {
    // Videa mají v detailu média nastavení "Kontrolovat aktuální verzi".
    // Hodnota se předává v parametrech média.
    return medium.params?.checkFile ?? false;
  }

  /** @inheritdoc */
  getSourceCreator() {
    return this.viewerSourceCreator;
  }

  /** @inheritdoc */
  getUrl(medium) {
    return new Promise((resolve) => resolve(medium.url ?? undefined));
  }

  /** @inheritdoc */
  isExtractable() {
    return false;
  }

  /** @inheritdoc */
  isOfflineable() {
    return false;
  }

  /** @inheritdoc */
  isPreloadable(medium) {
    return true;
  }
}

export default ViewerTypeVideo;
